$(document).ready(function(){
  var t;

  $(document).on('keyup', '#search, .search',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $('#filterFormId').submit();
      $("#loader-image").show();
    }, 500);
  });

  $(document).on('keyup', '#registered_sellers_search',  function() {
    var ad_id = $("#ad_id").val();
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/auctions/' + ad_id + '/search/seller_filter',
        type: 'GET',
        data: {search : $("#registered_sellers_search").val()}
      });
    }, 500);
  });

  $(document).on('keyup, change', '#user_search, #user_office_type_search',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/users/search/user_filter',
        type: 'POST',
        data: {search : $("#user_search").val(), office_type : $("#user_office_type_search option:selected").val()}
      });
    }, 500);
  });

  $(document).on('change', '#seller_search, #seller_status_type_search, #seller_order_type_search',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/sellers/search/user_filter',
        type: 'POST',
        data: {search : $("#seller_search").val(), status_type : $("#seller_status_type_search option:selected").val(), order_type : $("#seller_order_type_search option:selected").val()}
      });
    }, 500);
  });

  $(document).on('change', '#principal_search, #principal_status_type_search, #principal_order_type_search',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/principals/search/user_filter',
        type: 'GET',
        data: {search : $("#principal_search").val(), status_type : $("#principal_status_type_search option:selected").val(), order_type : $("#principal_order_type_search option:selected").val()}
      });
    }, 500);
  });

  $(document).on('change', '#bidder_search, #bidder_status_type_search, #bidder_order_type_search',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/bidders/search/user_filter',
        type: 'GET',
        data: {page: 1, search : $("#bidder_search").val(), status_type : $("#bidder_status_type_search option:selected").val(), order_type : $("#bidder_order_type_search option:selected").val()}
      });
    }, 500);
  });

  $(document).on('keyup, change', '#auction_title_search, #auction_order_type_search',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/auctions/search/ad_filter',
        type: 'GET',
        data: {search : $("#auction_title_search").val(), order_type : $("#auction_order_type_search option:selected").val(), category_type: $("#category_type").val()}
      });
    }, 500);
  });

  $(document).on('change', '#active_bid_search, #active_bid_status_search',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/offers/search/active_bid_filter',
        type: 'GET',
        data: {search : $("#active_bid_search").val(), status_type : $("#active_bid_status_search option:selected").val()}
      });
    }, 500);
  });

  $(document).on('change', '#active_auction_search, #active_auction_status, #active_auction_approval_status, #upcoming_auction_search, #upcoming_auction_status, #upcoming_auction_approval_status, #failed_auction_search, #failed_auction_status, #successful_auction_search, #successful_auction_filter_by_years, #successful_auction_filter_by_months',  function() {
    var type = $("#user_type").val();
    var first_status_type = $("#first_status_type").val();
    var second_status_type = $("#second_status_type").val();
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/offers/search/auction_filter',
        type: 'GET',
        data: { type: type,
                first_status_type: first_status_type,
                second_status_type: second_status_type,
                active_auction_search : $("#active_auction_search").val(),
                active_auction_status_type : $("#active_auction_status option:selected").val(),
                active_auction_approval_status : $("#active_auction_approval_status option:selected").val(),
                upcoming_auction_search : $("#upcoming_auction_search").val(),
                upcoming_auction_status_type : $("#upcoming_auction_status option:selected").val(),
                upcoming_auction_approval_status : $("#upcoming_auction_approval_status option:selected").val(),
                failed_auction_search : $("#failed_auction_search").val(),
                failed_auction_status_type : $("#failed_auction_status option:selected").val(),
                successful_auction_search : $("#successful_auction_search").val(),
                successful_auction_filter_by_years : $("#successful_auction_filter_by_years option:selected").val(),
                successful_auction_filter_by_months : $("#successful_auction_filter_by_months option:selected").val()
              }
      });
    }, 500);
  });

  $(document).on('change', '#active_notice_search, #active_notice_approval_status, #upcoming_notice_search, #upcoming_notice_approval_status, #cancelled_notice_search, #cancelled_notice_filter_by_years, #cancelled_notice_filter_by_months, #successful_notice_search, #successful_notice_filter_by_years, #successful_notice_filter_by_months',  function() {
    var type = $("#user_type").val();
    var first_status_type = $("#first_status_type").val();
    var second_status_type = $("#second_status_type").val();
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/offers/search/notice_filter',
        type: 'GET',
        data: { type: type,
                first_status_type: first_status_type,
                second_status_type: second_status_type,
                active_notice_search : $("#active_notice_search").val(),
                active_notice_approval_status: $("#active_notice_approval_status option:selected").val(),
                upcoming_notice_search : $("#upcoming_notice_search").val(),
                upcoming_notice_approval_status: $("#upcoming_notice_approval_status option:selected").val(),
                cancelled_notice_search : $("#cancelled_notice_search").val(),
                cancelled_notice_filter_by_years : $("#cancelled_notice_filter_by_years option:selected").val(),
                cancelled_notice_filter_by_months : $("#cancelled_notice_filter_by_months option:selected").val(),
                successful_notice_search : $("#successful_notice_search").val(),
                successful_notice_filter_by_years : $("#successful_notice_filter_by_years option:selected").val(),
                successful_notice_filter_by_months : $("#successful_notice_filter_by_months option:selected").val(),
              }
      });
    }, 500);
  });

  $(document).on('change', '#active_ad_search, #active_sales_ad_approval_status, #upcoming_ad_search, #upcoming_sales_ad_approval_status, #cancelled_ad_search, #cancelled_ad_filter_by_years, #cancelled_ad_filter_by_months, #successful_ad_search, #successful_ad_filter_by_years, #successful_ad_filter_by_months',  function() {
    var type = $("#user_type").val();
    var first_status_type = $("#first_status_type").val();
    var second_status_type = $("#second_status_type").val();
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/offers/search/ad_filter',
        type: 'GET',
        data: { type: type,
                first_status_type: first_status_type,
                second_status_type: second_status_type,
                active_ad_search : $("#active_ad_search").val(),
                active_sales_ad_approval_status: $("#active_sales_ad_approval_status option:selected").val(),
                upcoming_ad_search : $("#upcoming_ad_search").val(),
                upcoming_sales_ad_approval_status: $("#upcoming_sales_ad_approval_status option:selected").val(), 
                cancelled_ad_search : $("#cancelled_ad_search").val(),
                cancelled_ad_filter_by_years : $("#cancelled_ad_filter_by_years option:selected").val(),
                cancelled_ad_filter_by_months : $("#cancelled_ad_filter_by_months option:selected").val(),
                successful_ad_search : $("#successful_ad_search").val(),
                successful_ad_filter_by_years : $("#successful_ad_filter_by_years option:selected").val(),
                successful_ad_filter_by_months : $("#successful_ad_filter_by_months option:selected").val()
              }
      });
    }, 500);
  });

  $(document).on('keyup, change', '#wishlist_search, #wishlist_category_status',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/offers/search/wishlist_bid_filter',
        type: 'GET',
        data: {search : $("#wishlist_search").val(), status_type : $("#wishlist_category_status option:selected").val()}
      });
    }, 500);
  });

  $(document).on('keyup, change', '#winning_bid_search, #filter_by_years, #filter_by_months',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/offers/search/winning_bid_filter',
        type: 'GET',
        data: {search : $("#winning_bid_search").val(), filter_by_year : $("#filter_by_years option:selected").val(), filter_by_month : $("#filter_by_months option:selected").val()}
      });
    }, 500);
  });

  $(document).on('change', '#new_ad_approval_search, #new_ad_approval_status, #ad_content_changes_search, #ad_content_changes_status',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/admin/offers/search/new_ad_approval_filter',
        type: 'GET',
        data: {search : $("#new_ad_approval_search").val(), status_type : $("#new_ad_approval_status option:selected").val(), content_search : $("#ad_content_changes_search").val(), content_status_type : $("#ad_content_changes_status option:selected").val()}
      });
    }, 500);
  });

  $(document).on('keyup, change', '#open_invoice_search_status, #open_invoice_filter_by_years, #open_invoice_filter_by_months',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/invoices/search/open_invoice_filter',
        type: 'GET',
        data: {open_invoice_search_status : $("#open_invoice_search_status option:selected").val(), open_invoice_filter_by_years : $("#open_invoice_filter_by_years option:selected").val(), open_invoice_filter_by_months : $("#open_invoice_filter_by_months option:selected").val()}
      });
    }, 500);
  });

  $(document).on('keyup, change', '#own_open_invoice_search_status, #own_open_invoice_filter_by_years, #own_open_invoice_filter_by_months',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/invoices/search/own_open_invoice_filter',
        type: 'GET',
        data: {open_invoice_search_status : $("#own_open_invoice_search_status option:selected").val(), open_invoice_filter_by_years : $("#own_open_invoice_filter_by_years option:selected").val(), open_invoice_filter_by_months : $("#own_open_invoice_filter_by_months option:selected").val()}
      });
    }, 500);
  });

  $(document).on('keyup, change', '#paid_invoice_search_status, #paid_invoice_filter_by_years, #paid_invoice_filter_by_months',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/invoices/search/paid_invoice_filter',
        type: 'GET',
        data: {paid_invoice_search_status : $("#paid_invoice_search_status option:selected").val(), paid_invoice_filter_by_years : $("#paid_invoice_filter_by_years option:selected").val(), paid_invoice_filter_by_months : $("#paid_invoice_filter_by_months option:selected").val()}
      });
    }, 500);
  });

  $(document).on('keyup, change', '#own_paid_invoice_search_status, #own_paid_invoice_filter_by_years, #own_paid_invoice_filter_by_months',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/invoices/search/own_paid_invoice_filter',
        type: 'GET',
        data: {paid_invoice_search_status : $("#own_paid_invoice_search_status option:selected").val(), paid_invoice_filter_by_years : $("#own_paid_invoice_filter_by_years option:selected").val(), paid_invoice_filter_by_months : $("#own_paid_invoice_filter_by_months option:selected").val()}
      });
    }, 500);
  });

  $(document).on('keyup, change', '#open_sent_invoice_search_status, #open_sent_invoice_filter_by_years, #open_sent_invoice_filter_by_months, #principal_search',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/invoices/search/open_and_sent_invoice_filter',
        type: 'GET',
        data: {principal_search: $("#principal_search").val(), open_sent_invoice_search_status : $("#open_sent_invoice_search_status option:selected").val(), open_sent_invoice_filter_by_years : $("#open_sent_invoice_filter_by_years option:selected").val(), open_sent_invoice_filter_by_months : $("#open_sent_invoice_filter_by_months option:selected").val()}
      });
    }, 500);
  });

  $(document).on('keyup, change', '#archived_invoice_search_status, #archived_invoice_filter_by_years, #archived_invoice_filter_by_months, #principal_search_for_archived_invoice',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/invoices/search/archived_invoice_filter',
        type: 'GET',
        data: {principal_search_for_archived_invoice: $("#principal_search_for_archived_invoice").val(), archived_invoice_search_status : $("#archived_invoice_search_status option:selected").val(), archived_invoice_filter_by_years : $("#archived_invoice_filter_by_years option:selected").val(), archived_invoice_filter_by_months : $("#archived_invoice_filter_by_months option:selected").val()}
      });
    }, 500);
  });

  $(document).on('keyup', '#trusted_seller_open_invoices_search',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/invoices/search/trusted_sellers_invoices_filter',
        type: 'GET',
        data: {trusted_seller_open_invoices_search : $("#trusted_seller_open_invoices_search").val()}
      });
    }, 500);
  });

  $(document).on('keyup, change', '#trusted_seller_created_invoices_search, #trusted_seller_created_invoice_filter_by_years, #trusted_seller_created_invoice_filter_by_months',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/invoices/search/trusted_sellers_invoices_filter',
        type: 'GET',
        data: {trusted_seller_created_invoices_search : $("#trusted_seller_created_invoices_search").val(), trusted_seller_created_invoice_filter_by_years : $("#trusted_seller_created_invoice_filter_by_years option:selected").val(), trusted_seller_created_invoice_filter_by_months : $("#trusted_seller_created_invoice_filter_by_months option:selected").val()}
      });
    }, 500);
  });

  $(document).on('keyup, change', '#accounted_invoices_search, #accounted_invoice_filter_by_years, #accounted_invoice_filter_by_months',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/invoices/search/accounted_invoices_filter',
        type: 'GET',
        data: {accounted_invoices_search : $("#accounted_invoices_search").val(), accounted_invoice_filter_by_years : $("#accounted_invoice_filter_by_years option:selected").val(), accounted_invoice_filter_by_months : $("#accounted_invoice_filter_by_months option:selected").val()}
      });
    }, 500);
  });

  $(document).on('keyup, change', '#trusted_seller_cancelled_invoices_search, #trusted_seller_cancelled_invoice_filter_by_years, #trusted_seller_cancelled_invoice_filter_by_months',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/invoices/search/trusted_sellers_invoices_filter',
        type: 'GET',
        data: {trusted_seller_cancelled_invoices_search : $("#trusted_seller_cancelled_invoices_search").val(), trusted_seller_cancelled_invoice_filter_by_years : $("#trusted_seller_cancelled_invoice_filter_by_years option:selected").val(), trusted_seller_cancelled_invoice_filter_by_months : $("#trusted_seller_cancelled_invoice_filter_by_months option:selected").val()}
      });
    }, 500);
  });

  $(document).on('keyup, change', '#product_group_filter',  function() {
    var seller_id = $("#seller_id").val();
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/invoices/' + seller_id + '/filter_customer_info',
        type: 'GET',
        data: {product_group_filter : $("#product_group_filter").val()}
      });
    }, 500);
  });

  $(document).on('keyup, change', '#one_time_seller_open_invoices_search, #one_time_seller_open_invoice_search_status',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/invoices/search/one_time_sellers_invoices_filter',
        type: 'GET',
        data: {one_time_seller_open_invoices_search : $("#one_time_seller_open_invoices_search").val(), one_time_seller_open_invoice_search_status : $("#one_time_seller_open_invoice_search_status option:selected").val()}
      });
    }, 500);
  });

  $(document).on('keyup, change', '#one_time_seller_paid_invoices_search, #one_time_seller_paid_invoice_filter_by_years, #one_time_seller_paid_invoice_filter_by_months, #one_time_seller_paid_invoice_search_status',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/invoices/search/one_time_sellers_invoices_filter',
        type: 'GET',
        data: {one_time_seller_paid_invoices_search : $("#one_time_seller_paid_invoices_search").val(),
               one_time_seller_paid_invoice_filter_by_years : $("#one_time_seller_paid_invoice_filter_by_years option:selected").val(),
               one_time_seller_paid_invoice_filter_by_months : $("#one_time_seller_paid_invoice_filter_by_months option:selected").val(),
               one_time_seller_paid_invoice_search_status : $("#one_time_seller_paid_invoice_search_status option:selected").val()}
      });
    }, 500);
  });

  $(document).on('keyup, change', '#one_time_seller_cancelled_invoices_search, #one_time_seller_cancelled_invoice_filter_by_years, #one_time_seller_cancelled_invoice_filter_by_months, #one_time_seller_cancelled_invoice_search_status',  function() {
    clearTimeout(t);
    t = setTimeout(function () {
      $("#loader-image").show();
      $.ajax({
        url: '/invoices/search/one_time_sellers_invoices_filter',
        type: 'GET',
        data: {one_time_seller_cancelled_invoices_search : $("#one_time_seller_cancelled_invoices_search").val(),
               one_time_seller_cancelled_invoice_filter_by_years : $("#one_time_seller_cancelled_invoice_filter_by_years option:selected").val(),
               one_time_seller_cancelled_invoice_filter_by_months : $("#one_time_seller_cancelled_invoice_filter_by_months option:selected").val(),
               one_time_seller_cancelled_invoice_search_status : $("#one_time_seller_cancelled_invoice_search_status option:selected").val()}
      });
    }, 500);
  });
});